module.exports = __webpack_public_path__ + "img/icon.1535f16b.png";